export const purgeObjectFromFalsyValues = (ob: {}, ignoreZero = false) =>
  Object.entries(ob).reduce(
    (prev, [key, val]) =>
      val || (ignoreZero && Number(val) === 0) ? { ...prev, [key]: val } : prev,
    {}
  );
